import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { GUIDES } from '../content/guides';

// Rendered for any URL no route matches. The build prerenders it to dist/404.html, which the API
// serves with a 404 status so search engines drop dead URLs instead of indexing them as the home page.
export function NotFoundPage(): JSX.Element {
  const links = [
    { label: 'Home', href: '/' },
    { label: 'Features', href: '/features' },
    ...(GUIDES.length > 0 ? [{ label: 'Guides', href: '/guides' }] : []),
    { label: 'Pricing', href: '/pricing' },
    { label: 'Contact', href: '/contact' },
  ];

  return (
    <>
      <SEO
        title="Page not found"
        description="This page doesn't exist on resida.me. It may have moved, or the link may be mistyped."
        noindex
      />

      <section className="min-h-[60vh] pt-12 pb-[var(--landing-section-py)] bg-[var(--landing-bg)]">
        <div className="max-w-[var(--landing-container-max)] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[var(--landing-text-primary)] leading-tight mb-4">
              Page not found
            </h1>
            <p className="text-lg text-[var(--landing-text-muted)] mb-8">
              We couldn&apos;t find that page. It may have moved, or the link may be mistyped.
            </p>
            <nav aria-label="Site pages" data-testid="not-found-links">
              <ul className="flex flex-wrap gap-x-6 gap-y-3">
                {links.map(({ label, href }) => (
                  <li key={href}>
                    <Link to={href} className="font-medium text-[var(--landing-accent-text)] hover:underline">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>
      </section>
    </>
  );
}
